// extracted by mini-css-extract-plugin
export default {"form_header":"formHeader_form_header__Jy9kV"};